import React from "react";

export const Gallery = (props) => {
  return (
    <div id="bio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Bio</h2>
          <p>Hi, I'm Jim W., an experienced Accounting Specialist based in Elkhart, IN. I have over 5 years of experience running my own bookkeeping firm, serving a diverse range of industries such as e-commerce, SEO optimization, consulting, and medical fields. I specialize in QuickBooks, with certifications as a QuickBooks ProAdvisor, and I help businesses with everything from full-scale cleanups to ongoing monthly reconciliations.</p>
          <p>Before starting my firm, I spent 5 years in a fast-paced, publicly traded manufacturing environment, where I assisted in various projects and helped the company grow rapidly. My goal is to provide accurate and insightful financial management services that help businesses streamline their operations and achieve financial clarity.</p>
        </div>
      </div>
    </div>
  );
};
